<template>
    <div class="addressListWrap fc">
        <div class="content fc">
            <div v-for="(item, index) in addressList" :key="index" @click="selectAddress(index)" class="item fr ac jsb">
                <span v-show="item.isdefault == 'Y'" class="default_txt">默认</span>
                <span v-show="item.isdefault != 'Y'" class="placeholder"></span>
                <div class="info fc">
                    <p>
                        <span>{{item.realname}}</span>
                        <span>{{item.mobile}}</span>
                    </p>
                    <p>
                        <span>{{item.provincename}}</span>
                        <span>{{item.cityname}}</span>
                        <span>{{item.countyname}}</span>
                        <span>{{item.address}}</span>
                    </p>
                </div>
                <img @click.stop="editAddress(item)" src="../../../static/imgs/movie/modify.png" class="edit" alt />
            </div>
            <div class="addAddress center">
                <button @click="addAddress">添加收货地址</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            addressList: []
        };
    },
    components: {},
    created() {
        this.getAddressList();
    },
    methods: {
        getAddressList() {
            this.$post({
                method: "member.drama.express.address.list",
                auth_code: this.getLocal("auth_code")
            }).then(res => {
                if (res.success) {
                    let addresslist = res.data.addresslist
                    this.addressList = addresslist;
                    if(addresslist.length && this.getLocal("selectedAddress")){
                        // console.log(addresslist, this.getLocal("selectedAddress"))
                        let selectedAddress = this.getLocal("selectedAddress")
                        for (let i of addresslist){
                            if(i.id == selectedAddress.id){
                                this.setLocal("selectedAddress", i)
                            }
                        }
                    }
                }
            });
        },
        addAddress(){
            this.$router.push("/newAddress")
        },
        selectAddress(idx){
            this.setLocal("selectedAddress", this.addressList[idx])
            this.$router.go(-1)
        },
        editAddress(item){
            console.log(item)
            this.$router.push({path:"/newAddress", query: {isEdit: true, info: JSON.stringify(item)}})
        }
    }
};
</script>
<style lang="scss">
.addressListWrap {
    .content {
        margin-top: 20px;
        background: #fff;
        .item {
            width: 100%;
            padding: 20px 30px;
            box-sizing: border-box;
            font-size: 28px;
            border-bottom: 1px solid #c8c7cc;
            .default {
                width: 36px;
                margin-right: 10px;
                text-align: center;
                padding: 5px 0;
                color: #fff;
            }
            .placeholder {
                width: 60px;
                height: 30px;
            }
            .default_txt {
                width: 60px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                background: #E42F46;
                color: #fff;
                font-size: 20px;
                border-radius: 5px;
            }
            .info {
                // width: calc(100% - 90px);
                width: calc(100% - 134px);
                p {
                    span {
                        display: inline-block;
                        line-height: 42px;
                        margin-right: 10px;
                    }
                }
            }
            .edit {
                width: 30px;
                height: 30px;
                margin-left: 10px;
            }
        }
        .addAddress {
            height: 120px;
            button {
                width: 200px;
                height: 60px;
                line-height: 60px;
                border: 1px solid #E42F46;
                color: #E42F46;
                font-size: 28px;
                background: #fff;
                border-radius: 8px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/address/addressList.vue